<template>
  <div id="order-chat">
    <div class="order-content">
      <div class="order-header">
        <el-card v-for="(i,j) in orderCards" :key="j" class="order-card">
          <div class="order-icon"><img src="../../assets/order_icon.png" :alt="i.title"></div>
          <div class="order-con">
            <div class="order-title">{{ i.title }}</div>
            <div class="order-total">{{ i.order }}</div>
          </div>
        </el-card>
      </div>
      <div class="order-c-title divider-text is-always-shadow" style="padding-top: 70px;">
        <div class="order-title-top1" :class="isFixed?'order-violet':'order-white'"
             :style="{ width: isFixed? `calc(100% - ${ opened? 234 : 78}px)`: '', position: isFixed? 'fixed' : 'absolute' , top: 0, boxShadow: isFixed? '0px 15px 10px -15px rgba(0,0,0,0.4)':'',borderBottom: isFixed?'1px solid rgb(223, 226, 229)':''}">
          <div class="order-title-top-left f-w-b">
            订单量统计
<!--            <el-tooltip placement="top-start">-->
<!--              <div slot="content">-->
<!--                1.订单量：真实的服务订单，不含已取消和未支付后失效的订单。<br>-->
<!--                2.区域分布：用户下单时填写的预约地址。<br>-->
<!--                3.取消订单量：用户发起后客服通过为用户取消，用户未申请客服发起为客服取消。<br>-->
<!--              </div>-->
<!--              <img src="../../assets/ic_Info.png" alt="" style="width: 20px;height: 20px;margin-left: 5px">-->
<!--            </el-tooltip>-->
          </div>
          <div class="order-title-top-right1">
            <div class="query-content">
              <el-radio-group v-model="timeVal" @change="timeChange">
                <el-radio-button v-for="item in timeOptions" :key="item.value" :label="item.value">{{ item.label }}
                </el-radio-button>
              </el-radio-group>
              <el-select v-model="statusValue" placeholder="请选择" @change="orderState">
                <el-option v-for="item in orderoptions" :key="item.value" :label="item.label" :value="item.value"/>
              </el-select>
              <el-date-picker v-if="timeVal == 4" v-model="anyVal" :clearable="false"
                              :picker-options="daterangePickerOptions" type="daterange" style="width: 341px"
                              start-placeholder="开始日期" end-placeholder="结束日期" @change="timeChange"/>
              <div v-if="timeVal == 'month'">
                <i class="el-icon-d-arrow-left" style="cursor:pointer;" @click="upTime"/>
                <el-date-picker v-model="mouthVal" :clearable="false" :picker-options="mouthPickerOptions" type="month"
                                placeholder="请选择月" @change="timeChange"/>
                <i class="el-icon-d-arrow-right" :style="isDowTime ? 'color: #dfdfdf;' : 'cursor:pointer;'"
                   @click="downTime"/>
              </div>
              <div v-if="timeVal == 'year'">
                <i class="el-icon-d-arrow-left" style="cursor:pointer;" @click="upTime"/>
                <el-date-picker v-model="yearVal" :clearable="false" :picker-options="yearPickerOptions" type="year"
                                placeholder="请选择年" @change="timeChange"/>
                <i class="el-icon-d-arrow-right" :style="isDowTime ? 'color: #dfdfdf;' : 'cursor:pointer;'"
                   @click="downTime"/>
              </div>
            </div>
          </div>
        </div>
        <!-- 订单统计 -->
        <div class="order-c-title divider-text" style="padding-right: 10px;padding-left: 10px">
          <div class="order-title-top order-grey"
               style="border-left: 1px solid #DFE2E5;border-top: 1px solid #DFE2E5;border-right: 1px solid #DFE2E5;">
            <div class="order-title-top-left">订单数量</div>
            <div class="order-title-top-right">
              <div class="orange-box"/>
              <div class="order-title-top-right-box">
                本期合计：{{ goodsOrder.total_current }}
              </div>
              <div class="blue-box"/>
              <div class="order-title-top-right-box">
                同期合计：{{ goodsOrder.total_previous }}
              </div>
              <div class="order-title-top-right-box">
                同比：
                <img v-if="goodsOrder.yoy > 0" src="" alt="">
                <img v-if="goodsOrder.yoy <= 0" src="" alt="">
                <span :class="goodsOrder.yoy > 0 ? 'f-green' : 'f-orange'">{{ goodsOrder.yoy }}</span>
              </div>
            </div>
          </div>
          <order-chart :id="'Order'" :goods-order="goodsOrder" class-name="chat" width="100%"/>
        </div>

        <!-- 同比环比 -->
        <div class="order-c-title divider-text" style="padding-right: 10px;padding-left: 10px">
          <div class="order-title-top order-grey"
               style="border-left: 1px solid #DFE2E5;border-top: 1px solid #DFE2E5;border-right: 1px solid #DFE2E5;">
            <div class="order-title-top-left">订单量同比/环比</div>
            <div class="order-title-top-right">
              <div class="blue-box2"/>
              <div class="order-title-top-right-box">
                订单量同比
              </div>
              <div class="orange-box2"/>
              <div class="order-title-top-right-box">
                订单量环比
              </div>
            </div>
          </div>
          <yo-y-chart :id="'Yoy'" :goods-broken-line="goodsOrder" class-name="chat" width="100%"/>
        </div>
      </div>
      <!-- 取消订单 -->
      <div class="order-c-title divider-text" style="margin-top: 20px;">
        <div class="order-title-top order-white">
          <div class="order-title-top-left f-w-b">服务订单量</div>
        </div>
        <div class="cancel-chat">
          <!-- 取消订单量 -->
          <div class="q-chat box-shadow">
            <div class="order-title-top order-grey" style="border-bottom: 1px solid #DFE2E5;">
              <div class="order-title-top-left">服务订单量</div>
            </div>
            <div style="height: 554px">
              <aptitude-chart id="sell-aptitude" :goods-pie-product="goodsPieChartByProduct" class-name="s-chat" width="100%" height="554px" />
            </div>
          </div>
          <!-- 取消订单量 -->
          <div class="q-chat box-shadow">
            <div class="order-title-top order-grey" style="border-bottom: 1px solid #DFE2E5;">
              <div class="order-title-top-left">取消订单量</div>
            </div>
            <div style="height: 554px">
              <cancel-order-chart id="cancel-order" :goods-by-histogram="goodsByCancelHistogram" class-name="c-chat"
                                  width="100%" height="554px"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OrderChart from './components/OrderChart'
import YoYChart from './components/YoYChart'
import CancelOrderChart from './components/CancelOrderChart'
import {
  nextDate,
  prevDate,
  formatDate
} from 'element-ui/src/utils/date-util'
import {
  getWeekNumber,
  nextMonthDate,
  nextYearDate,
  prevMonthDate,
  prevYearDate,
  yearDate
} from '../../utils/date-util'
import {
  fetchStatisticsOrderCancel,
  fetchStatisticsOrderPieChart,
  fetchStatisticsOrderQuantity,
  fetchStatisticsOrderYmw
} from '../../api'
import AptitudeChart from './components/AptitudeChart'

const NowDate = new Date()
export default {
  name: 'OrderChat',
  components: { AptitudeChart, YoYChart, OrderChart, CancelOrderChart },
  data() {
    return {
      timeVal: 'year',
      weekVal: '',
      mouthVal: '',
      yearVal: '',
      anyVal: '',
      pickerMinDate: '',
      cancelPickerMinDate: '',
      dateRange: [],
      statusValue: '',

      cancelTimeVal: 2,
      cancelWeekVal: '',
      cancelMouthVal: '',
      cancelYearVal: '',
      cancelAnyVal: '',
      cancelStatusValue: '',

      goodsOrder: '',
      goodsBrokenLine: '',
      goodsPieChartByProduct: '',
      goodsRankingByCityPage: '',
      goodsOrderMapByCity: '',
      goodsByCancelHistogram: '',
      goodsRankingByCancelPag: '',
      categoryReceptionButton: 'primary',
      rankingReceptionButton: '',
      cancelCategoryReceptionButton: 'primary',
      cancelRankingReceptionButton: '',
      cancelOperaType: 0,
      iconState: true,
      isFixed: false, // 吸顶条件
      cities: [],
      address: '',
      weekPickerOptions: {
        firstDayOfWeek: 1,
        disabledDate(val) {
          return val > NowDate
        }
      },
      mouthPickerOptions: {
        disabledDate(val) {
          return val > NowDate
        }
      },
      yearPickerOptions: {
        disabledDate(val) {
          return val > NowDate
        }
      },
      daterangePickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          if (maxDate) {
            this.pickerMinDate = ''
          } else {
            this.pickerMinDate = minDate.getTime()
          }
        },
        disabledDate: (time) => {
          if (this.pickerMinDate !== '') {
            const day60 = (60 - 1) * 24 * 3600 * 1000
            let maxTime = this.pickerMinDate + day60
            const minTime = this.pickerMinDate - day60
            if (maxTime > new Date()) {
              maxTime = new Date()
            }
            return time.getTime() < minTime || time.getTime() > maxTime
          }
          return time.getTime() > Date.now()
        }
      },
      cancelWeekPickerOptions: {
        firstDayOfWeek: 1,
        disabledDate(val) {
          return val > NowDate
        }
      },
      cancelMouthPickerOptions: {
        disabledDate(val) {
          return val > NowDate
        }
      },
      cancelYearPickerOptions: {
        disabledDate(val) {
          return val > NowDate
        }
      },
      cancelDaterangePickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          if (maxDate) {
            this.cancelPickerMinDate = ''
          } else {
            this.cancelPickerMinDate = minDate.getTime()
          }
        },
        disabledDate: (time) => {
          if (this.cancelPickerMinDate !== '') {
            const day60 = (60 - 1) * 24 * 3600 * 1000
            let maxTime = this.cancelPickerMinDate + day60
            const minTime = this.cancelPickerMinDate - day60
            if (maxTime > new Date()) {
              maxTime = new Date()
            }
            return time.getTime() < minTime || time.getTime() > maxTime
          }
          return time.getTime() > Date.now()
        }
      },
      timeOptions: [
        { value: 'month', label: '按月' },
        { value: 'year', label: '按年' }
      ],
      orderCards: {
        weekOrder: { title: '近7天订单量', order: 0, icon: '' }, // 近7天订单量
        monthOrder: { title: '近30天订单量', order: 0, icon: '' }, // 近30天订单量
        yearOrder: { title: '本年订单量', order: 0, icon: '' }, // 本年订单量
        totalOrder: { title: '累计订单总量', order: 0, icon: '' } // 累计订单总量
      },
      orderoptions: [{
        value: '',
        label: '全部'
      }, {
        value: 1,
        label: '待接单'
      }, {
        value: 2,
        label: '待服务'
      }, {
        value: 3,
        label: '执行中'
      }, {
        value: '4,5',
        label: '已完成'
      }]
    }
  },
  computed: {
    isDowTime() {
      const { timeVal, weekVal, mouthVal, yearVal } = this
      if (timeVal === 1) {
        if (weekVal === '') {
          return false
        } else {
          const weekValC = nextDate(weekVal, weekVal.getDay() + 6)
          return weekValC > new Date()
        }
      }
      if (timeVal === 2) {
        if (mouthVal === '') {
          return false
        } else {
          const mouthValC = nextMonthDate(mouthVal, 1)
          return mouthValC > new Date()
        }
      }
      if (timeVal === 3) {
        if (yearVal === '') {
          return false
        } else {
          const yearValC = nextYearDate(yearVal, 1)
          return yearValC.getFullYear() > new Date().getFullYear()
        }
      }
      return false
    },
    rankingList() {
      return this.$store.getters.roles.findIndex(i => i.code === 'rankingList') > -1
    },
    opened() {
      return this.$store.state.app.sidebar.opened
    }
  },
  created() {
    this.getstatisticsBaseInfo()
    this.timeChange()
  },
  mounted() {
    window.addEventListener('scroll', this.scrollToTop)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollToTop)
  },
  methods: {
    // 获取订单卡片基本数据
    getstatisticsBaseInfo() {
      fetchStatisticsOrderQuantity().then(res => {
        const { last_seven_days, last_thirty_days, last_year_days, order_total } = res.data
        this.orderCards.weekOrder.order = last_seven_days // 最近7天订单量
        this.orderCards.monthOrder.order = last_thirty_days // 最近30天的订单量
        this.orderCards.yearOrder.order = last_year_days // 本年订单量
        this.orderCards.totalOrder.order = order_total // 累计订单总量
      })
    },
    /**
       * 订单统计-柱状图接口
       * 2020-1-10 11:02:55
       * @author GJ
       */
    getGoodsOrderHistogram(params) {
      fetchStatisticsOrderYmw(params).then(res => {
        this.goodsOrder = res.data
      })
    },
    /**
       * 订单统计-品类饼图/TOP排行
       * 2020-1-13 13:55:51
       * @author GJ
       */
    getGoodsOrderPieChartByProduct(params) {
      fetchStatisticsOrderPieChart(params).then(res => {
        this.goodsPieChartByProduct = res.data
      })
    },
    /**
       * 订单统计-取消订单柱状图
       * 2020-1-15 10:17:21
       * @author GJ
       */
    getGoodsOrderByCancelHistogram(params) {
      fetchStatisticsOrderCancel(params).then(res => {
        this.goodsByCancelHistogram = res.data
      })
    },
    /**
       * 订单状态搜索
       * 2020-1-18 12:06:35
       * @author GJ
       */
    orderState() {
      this.timeChange()
    },
    /**
       * 页面滚动吸顶控制
       * 2019-12-5 14:10:09
       * @author SnowRock
       */
    scrollToTop() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      this.isFixed = scrollTop >= 225
    },
    /**
       * 订单状态时间向上
       * 2020-1-18 12:14:02
       * @author GJ
       */
    upTime() {
      const vm = this
      const { timeVal, weekVal, mouthVal, yearVal } = vm
      if (timeVal === '1') {
        if (weekVal === '') {
          vm.weekVal = prevDate(new Date(), (new Date().getDay() || 7) + 6)
        } else {
          vm.weekVal = prevDate(weekVal, (weekVal.getDay() || 7) + 6)
        }
      }
      if (timeVal === 'month') {
        if (mouthVal === '') {
          vm.mouthVal = prevMonthDate(new Date(), 1)
        } else {
          vm.mouthVal = prevMonthDate(mouthVal, 1)
        }
      }
      if (timeVal === 'year') {
        if (yearVal === '') {
          vm.yearVal = prevYearDate(new Date(), 1)
        } else {
          vm.yearVal = prevYearDate(yearVal, 1)
        }
      }
      vm.timeChange()
    },
    /**
       * 订单状态时间向上
       * 2020-1-18 12:14:02
       * @author GJ
       */
    downTime() {
      const vm = this
      const { timeVal, weekVal, mouthVal, yearVal } = vm
      if (timeVal === 1) {
        if (weekVal === '') {
          vm.weekVal = nextDate(new Date(), new Date().getDay() + 6)
        } else {
          const weekValC = nextDate(weekVal, weekVal.getDay() + 6)
          if (weekValC > new Date()) {
            vm.weekVal = weekVal
          } else {
            vm.weekVal = weekValC
          }
        }
      }
      if (timeVal === 'month') {
        if (mouthVal === '') {
          vm.mouthVal = nextMonthDate(new Date(), 1)
        } else {
          const mouthValC = nextMonthDate(mouthVal, 1)
          if (mouthValC > new Date()) {
            vm.mouthVal = mouthVal
          } else {
            vm.mouthVal = mouthValC
          }
        }
      }
      if (timeVal === 'year') {
        if (yearVal === '') {
          vm.yearVal = nextYearDate(new Date(), 1)
        } else {
          const yearValC = nextYearDate(yearVal, 1)
          if (yearValC > new Date()) {
            vm.yearVal = yearVal
          } else {
            vm.yearVal = yearValC
          }
        }
      }
      vm.timeChange()
    },
    /**
       * 订单统计筛选
       * 2020-1-10 11:02:55
       * @author GJ
       */
    timeChange() {
      const { timeVal, mouthVal, yearVal, weekVal } = this
      // 声明
      const type = timeVal
      let params = {}
      let yearTime
      let weekTime
      // 按周获取时间
      if (type === 'month') {
        if (mouthVal === '') {
          this.mouthVal = new Date()
          yearTime = formatDate(new Date(), 'yyyy-MM')
        } else {
          yearTime = formatDate(mouthVal, 'yyyy-MM')
        }
        // 按年获取时间
      } else if (type === 'year') {
        if (yearVal === '') {
          this.yearVal = new Date()
          yearTime = yearDate(new Date())
        } else {
          yearTime = yearDate(yearVal)
        }
        // 按自定义获取时间
      } else if (type === 'week') {
        if (weekVal === '') {
          this.weekVal = new Date()
          yearTime = yearDate(new Date())
          weekTime = getWeekNumber(new Date())
        } else {
          yearTime = yearDate(weekVal)
          weekTime = yearDate(weekVal)
        }
        // 按自定义获取时间
      }
      params = {
        type,
        date: yearTime || '',
        week: weekTime || ''
      }
      this.getGoodsOrderHistogram(params)
      this.getGoodsOrderPieChartByProduct(params)
      this.getGoodsOrderByCancelHistogram(params)
    }
  }
}
</script>

<style lang="scss" scoped>
  #order-chat {
    padding-top: 1px;
    padding-bottom: 1px;

    .order-content {
      min-height: calc(100vh - 110px);
      margin: 12px;
      border-radius: 8px;
      box-sizing: border-box;
    }

    .order-header {
      .el-card__body {
        padding: 15px !important;
      }

      .order-card {
        width: 18%;
        height: 108px;
        display: inline-block;
        margin-right: 1%;
        margin-bottom: 15px;
        box-sizing: border-box;

        .order-icon {
          width: 48px;
          margin-right: 15px;
          text-align: center;
          display: inline-block;
          vertical-align: middle;

          img {
            width: 48px;
            height: 48px;
          }
        }

        .order-con {
          width: calc(100% - 75px);
          display: inline-block;
          font-size: 16px;
          font-weight: bold;
          vertical-align: middle;
          color: #354052;

          .order-total {
            line-height: 29px;
            padding-bottom: 1px;
            padding-top: 7px;
            font-size: 22px;
          }

          .order-title {
            line-height: 29px;
            padding-top: 4px;
            padding-bottom: 11px;
            position: relative;

            &:after {
              content: '';
              width: 300px;
              height: 0;
              position: absolute;
              bottom: 0;
              left: 0;
              border-bottom: 1px dashed #CDCFD9;
            }
          }
        }
      }
    }

    .order-c-title {
      width: 100%;
      font-size: 20px;
      padding: 10px 0 10px 0;
      background: #fff;
      border-radius: 4px;
      color: #354052;
      position: relative;

      .query-content {
        display: flex;
        justify-content: flex-end;
      }

      .order-title-top1 {
        width: 100%;
        height: 80px;
        background: rgba(245, 245, 245, 1);
        border-radius: 2px 2px 0px 0px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        z-index: 2000;

        .order-title-top-left {
          margin-left: 22px;
          display: flex;
          align-items: center;
        }

        .order-title-top-right {
          display: flex;
          justify-content: space-between;
          align-items: center;

          img {
            width: 10px;
            height: 12px;
          }

          .order-title-top-right-box {
            margin-right: 20px;
            font-size: 16px;
            font-weight: 400;
            color: rgba(53, 64, 82, 1);
          }
        }

        .order-title-top-right1 {
          display: flex;
          justify-content: space-between;
        }

        .order-title-top-right1 div {
          margin-left: 10px;
          margin-right: 10px;
          font-size: 16px;
          font-weight: 400;
          color: rgba(53, 64, 82, 1);
        }

        .order-title-top-right-btn-box {
          border: rgba(51, 168, 255, 1);

          .el-button--primary {
            background: rgba(51, 168, 255, 1);
            border-color: rgba(51, 168, 255, 1);
          }

          .el-button.is-plain:hover, .el-button.is-plain:focus {
            color: rgba(51, 168, 255, 1);
            border-color: rgba(51, 168, 255, 1);
          }
        }
      }

      .order-title-top {
        width: 100%;
        height: 50px;
        background: rgba(245, 245, 245, 1);
        border-radius: 2px 2px 0px 0px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .order-title-top-left {
          margin-left: 22px;
          display: flex;
          align-items: center;
        }

        .order-title-top-right {
          display: flex;
          justify-content: space-between;
          align-items: center;

          img {
            width: 10px;
            height: 12px;
          }

          .order-title-top-right-box {
            margin-right: 20px;
            font-size: 16px;
            font-weight: 400;
            color: rgba(53, 64, 82, 1);
          }
        }

        .order-title-top-right1 {
          display: flex;
          justify-content: space-between;
        }

        .order-title-top-right1 div {
          margin-left: 10px;
          margin-right: 10px;
          font-size: 16px;
          font-weight: 400;
          color: rgba(53, 64, 82, 1);
        }

        .order-title-top-right-btn-box {
          border: rgba(51, 168, 255, 1);

          .el-button--primary {
            background: rgba(51, 168, 255, 1);
            border-color: rgba(51, 168, 255, 1);
          }

          .el-button.is-plain:hover, .el-button.is-plain:focus {
            color: rgba(51, 168, 255, 1);
            border-color: rgba(51, 168, 255, 1);
          }
        }
      }

      .order-white {
        background: rgba(255, 255, 255, 1);
      }

      .order-violet {
        background: rgba(245, 245, 246, 1);
      }

      .order-grey {
        background: rgba(245, 245, 245, 1);
      }

      .order-main {
        display: flex;
        justify-content: space-between;
      }
    }

    .chat {
      width: 100%;
      overflow: hidden;
      box-sizing: border-box;
      height: 400px;
      display: inline-block;
      border: 1px solid #DFE2E5;
    }

    .s-chat {
      width: 50%;
      overflow: hidden;
      box-sizing: border-box;
      height: 500px;
      display: inline-block;
    }

    .q-chat {
      width: calc(50% - 7.5px);
      overflow: hidden;
      box-sizing: border-box;
      display: inline-block;
      border: 1px solid #DFE2E5;
    }

    .c-chat {
      width: 100%;
      overflow: hidden;
      box-sizing: border-box;
      height: 554px;
      display: inline-block;
      border: 1px solid #DFE2E5;
    }

    .f-orange {
      font-weight: 600;
      color: rgba(244, 101, 101, 1);
    }

    .f-green {
      font-weight: 600;
      color: rgba(63, 203, 152, 1);
    }

    .topList {
      background: #0a76a4;
    }

    .toplistbox {
      height: 554px;
      max-height: 554px;
      overflow-y: auto;
    }

    .toplistbox2 {
      height: 600px;
      max-height: 600px;
      text-align: center;
      line-height: 600px;
      font-size: 30px;
      font-weight: bold;
      color: #ccc;
      overflow-y: auto;
    }

    .cancel-chat {
      width: 100%;
      padding: 10px;
      display: flex;
      justify-content: space-between;
    }

    .box-shadow {
      box-shadow: 0px 0px 14px 0px rgba(0, 0, 0, 0.04);
    }

    .blue-box,
    .orange-box,
    .blue-box2,
    .orange-box2,
    .prop-box {
      width: 15px;
      height: 15px;
      margin-right: 10px;
    }

    .blue-box {
      background-color: #2298F0;
    }

    .orange-box {
      background-color: #FF7800;
    }

    .blue-box2 {
      background-color: #FDB44F;
    }

    .orange-box2 {
      background-color: #886CE6;
    }

    .prop-box {
      background-color: #C5B2FF;
    }
  }
</style>
